import React, { useMemo, useState } from "react";
import { Chip, FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { DataTable, OsLink, Panel } from "./shared";

const INCONSISTENCY_LABELS = {
  filha_sem_pai: "Etapa sem pai",
  pai_sem_etapas: "Pai de implantação sem etapas",
  pai_objeto_padrao_divergente: "Objeto padrão da pai divergente",
  tipo_divergente: "Tipo diferente das irmãs",
  objeto_padrao_vazio: "Objeto padrão vazio",
  etapa_sem_numero: "Etapa sem número",
  filha_com_varias_pais: "Filha com várias pais"
};

const useStyles = makeStyles(theme => ({
  grid: { display: "grid", gap: theme.spacing(2), gridTemplateColumns: "minmax(0, 1fr)" },
  chips: { display: "flex", flexWrap: "wrap", gap: theme.spacing(1), marginBottom: theme.spacing(1.5) },
  select: { minWidth: 160 },
  diff: { fontWeight: 600 }
}));

const QualityTab = ({ data, validationDays, onValidationDaysChange }) => {
  const classes = useStyles();
  const [type, setType] = useState("");
  const counts = useMemo(() => data.inconsistencies.reduce((result, item) => ({
    ...result, [item.tipo]: (result[item.tipo] || 0) + 1
  }), {}), [data.inconsistencies]);
  const rows = type ? data.inconsistencies.filter(item => item.tipo === type) : data.inconsistencies;

  return (
    <div className={classes.grid}>
      <Panel title={`Relatório de inconsistências · ${data.inconsistencies.length}`}
        subtitle="OS que não seguem as regras do dashboard. Não depende dos filtros; corrija o cadastro no sistema de OS.">
        <div className={classes.chips}>
          <Chip label={`Todas · ${data.inconsistencies.length}`} color={type ? "default" : "primary"}
            variant={type ? "outlined" : "default"} onClick={() => setType("")} />
          {Object.keys(counts).map(key => (
            <Chip key={key} label={`${INCONSISTENCY_LABELS[key] || key} · ${counts[key]}`}
              color={type === key ? "primary" : "default"} variant={type === key ? "default" : "outlined"}
              onClick={() => setType(key)} />
          ))}
        </div>
        <DataTable rows={rows} rowKey={row => `${row.tipo}-${row.os_id}`} emptyText="Nenhuma inconsistência encontrada." maxHeight={480}
          columns={[
            { key: "tipo", label: "Regra", render: row => INCONSISTENCY_LABELS[row.tipo] || row.tipo },
            { key: "os_id", label: "OS", render: row => <OsLink id={row.os_id} /> },
            { key: "projeto_id", label: "Projeto", render: row => (row.projeto_id ? <OsLink id={row.projeto_id} /> : "-") },
            { key: "cliente", label: "Cliente", render: row => row.cliente || "-" },
            { key: "descricao", label: "Detalhe" }
          ]} />
      </Panel>

      <Panel title="Conferência com o Kanban"
        subtitle="Kanban: todas as OS do grupo abertas no período, por status ativo. Dashboard: apenas as OS que entram nas regras de projeto de implantação. Diferenças indicam OS fora das regras."
        actions={(
          <FormControl variant="outlined" size="small" className={classes.select}>
            <InputLabel id="implantation-validation-days">Período do Kanban</InputLabel>
            <Select labelId="implantation-validation-days" label="Período do Kanban" value={validationDays}
              onChange={event => onValidationDaysChange(event.target.value)}>
              {[30, 60, 90, 120].map(days => <MenuItem key={days} value={days}>Últimos {days} dias</MenuItem>)}
            </Select>
          </FormControl>
        )}>
        <DataTable rows={data.validation.linhas} rowKey={row => `${row.grupo_id}-${row.status}`} emptyText="Nenhuma OS no período."
          columns={[
            { key: "grupo", label: "Grupo" },
            { key: "status", label: "Status" },
            { key: "kanban", label: "Kanban", numeric: true },
            { key: "dashboard", label: "Dashboard", numeric: true },
            {
              key: "diferenca", label: "Diferença", numeric: true,
              render: row => <span className={row.kanban !== row.dashboard ? classes.diff : undefined}>{row.kanban - row.dashboard}</span>
            }
          ]} />
      </Panel>
    </div>
  );
};

export default QualityTab;
